import styled from '@emotion/styled/macro';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
`;

export const Items = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.p`
  font-weight: bold;
  color: var(--brand-black);
`;

export const Value = styled.p`
  color: var(--brand-black);
`;

export const LinkButton = styled.a`
  color: var(--brand-primary);
  text-decoration: none;
  font-weight: bold;
  line-height: 20px;
`;
